import React from "react";
import SquareLogo from '../../../../Resources/Logo/STC_Logo.png';

function STCLogoSquare(props){

    return(
        <img
            alt={'STCSquareLogo'}
            style={props.style}
            className={props.className}
            src={SquareLogo}
        />
    )
}
export default STCLogoSquare;